import L from 'leaflet';

const MAPCACHE_URL = 'https://paranamap.esteio.com.br/mapcache/';
const MAPSERVER_URL = 'https://paranamap.esteio.com.br/mapserver/';

const createFaixaVooLayer = (loteNum) =>
	L.tileLayer.wms(MAPCACHE_URL, {
		layers: `faixas_voo_'${loteNum}`,
		transparent: true,
		format: 'image/png',
		pointerCursor: true,
		maxZoom: 23,
		updateWhenIdle: true,
		updateWhenZooming: false,
		pane: `pane-Faixas de Voo Foto`, // zIndex 250, definido no addFaixaVooLayer
	});

export const wmsLayers = {
	'Articulação Sistemática 1:5.000': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_articulacao_sistematica_1_5000',
		transparent: true,
		format: 'image/png',
		crs: L.CRS.EPSG4326,
		maxZoom: 23,
		pane: 'pane-Articulação Sistemática 1:5.000',
	}),
	'Articulação Sistemática 1:10.000': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_articulacao_sistematica_1_10000',
		transparent: true,
		format: 'image/png',
		crs: L.CRS.EPSG4326,
		maxZoom: 23,
		pane: 'pane-Articulação Sistemática 1:10.000',
	}),
	'Articulação Sistemática 1:25.000': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_articulacao_sistematica_1_25000',
		format: 'png',
		transparent: true,
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Articulação Sistemática 1:25.000',
	}),
	'Articulação Auxiliar 1:5.000': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_articulacao_auxiliar_1_5000',
		format: 'png',
		transparent: true,
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Articulação Auxiliar 1:5.000',
	}),
	'Articulação Auxiliar 1:10.000': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_articulacao_auxiliar_1_10000',
		format: 'png',
		transparent: true,
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Articulação Auxiliar 1:10.000',
	}),
	'Área de Abrangência do Projeto': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_limite_pr_2km',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Área de Abrangência do Projeto',
	}),
	'Limite Municipais': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_limite_municipais',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Limite Municipais',
	}),
	'Limite Estadual - PR': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_limite_pr',
		format: 'image/png',
		transparent: true,
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Limite Estadual - PR',
	}),
	'Aeroporto': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_aeroporto',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Aeroporto',
	}),
	'Bases de Voo': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_base_voo',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Bases de Voo',
	}),
	'RBMC': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_rbmc',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-RBMC',
	}),
	'GPS': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_gps',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-GPS',
	}),
	'RN': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_rn',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-RN',
	}),
	'Nível de Dificuldade': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_nivel_dificuldade',
		transparent: 'true',
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Nível de Dificuldade',
	}),
	'Rodovias': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_rodovia',
		transparent: 'true',
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Rodovias',
	}),
	'Hidrografia': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_hidrografia',
		transparent: 'true',
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Hidrografia',
	}),
	'Camada de Áreas Urbanas': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_area_urbana',
		transparent: 'true',
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Camada de Áreas Urbanas',
	}),
	'Camada de Manchas de Clima': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_mancha_clima',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Camada de Manchas de Clima',
	}),
	'Camada de Precipitação': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_precipitacao',
		transparent: 'true',
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Camada de Precipitação',
	}),
	'Camada de Declividade': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_declividade',
		transparent: 'true',
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Camada de Declividade',
	}),
	'Camada de Vegetação': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_vegetacao',
		transparent: 'true',
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Camada de Vegetação',
	}),
	'Bacias IAT': L.tileLayer.wms(MAPCACHE_URL, {
		layers:  "info_bacia_iat",
		transparent: 'true',
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Bacias IAT',
	}),
	'Caminho do Peabiru': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_caminho_perabiru',
		transparent: 'true',
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		pane: 'pane-Caminho do Peabiru',
	}),
	'Lotes do Projeto::Lote 1': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_lotes_pr_1',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		updateWhenIdle: true,
		updateWhenZooming: false,
		keepBuffer: 2,
		pane: 'pane-Lotes do Projeto',
	}),
	'Lotes do Projeto::Lote 2': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_lotes_pr_2',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		updateWhenIdle: true,
		updateWhenZooming: false,
		keepBuffer: 2,
		pane: 'pane-Lotes do Projeto',
	}),
	'Lotes do Projeto::Lote 3': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_lotes_pr_3',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		updateWhenIdle: true,
		updateWhenZooming: false,
		keepBuffer: 2,
		pane: 'pane-Lotes do Projeto',
	}),
	'Lotes do Projeto::Lote 4': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_lotes_pr_4',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		updateWhenIdle: true,
		updateWhenZooming: false,
		keepBuffer: 2,
		pane: 'pane-Lotes do Projeto',
	}),
	'Lotes do Projeto::Lote 5': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_lotes_pr_5',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		updateWhenIdle: true,
		updateWhenZooming: false,
		keepBuffer: 2,
		pane: 'pane-Lotes do Projeto',
	}),
	'Lotes do Projeto::Lote 6': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_lotes_pr_6',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		updateWhenIdle: true,
		updateWhenZooming: false,
		keepBuffer: 2,
		pane: 'pane-Lotes do Projeto',
	}),
	'Lotes do Projeto::Lote 7': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_lotes_pr_7',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		updateWhenIdle: true,
		updateWhenZooming: false,
		keepBuffer: 2,
		pane: 'pane-Lotes do Projeto',
	}),
	'Lotes do Projeto::Lote 8': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_lotes_pr_8',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		updateWhenIdle: true,
		updateWhenZooming: false,
		keepBuffer: 2,
		pane: 'pane-Lotes do Projeto',
	}),
	'Lotes do Projeto::Lote 9': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_lotes_pr_9',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		updateWhenIdle: true,
		updateWhenZooming: false,
		keepBuffer: 2,
		pane: 'pane-Lotes do Projeto',
	}),
	'Lotes do Projeto::Lote 10': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_lotes_pr_10',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		updateWhenIdle: true,
		updateWhenZooming: false,
		keepBuffer: 2,
		pane: 'pane-Lotes do Projeto',
	}),
	'Lotes do Projeto::Lote 11': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_lotes_pr_11',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		updateWhenIdle: true,
		updateWhenZooming: false,
		keepBuffer: 2,
		pane: 'pane-Lotes do Projeto',
	}),
	'Lotes do Projeto::Lote 12': L.tileLayer.wms(MAPCACHE_URL, {
		layers: 'info_lotes_pr_12',
		transparent: true,
		format: 'png',
		crs: L.CRS.EPSG4326,
		pointerCursor: true,
		maxZoom: 23,
		updateWhenIdle: true,
		updateWhenZooming: false,
		keepBuffer: 2,
		pane: 'pane-Lotes do Projeto',
	}),

	'Faixas de Voo Foto::Lote 1':  createFaixaVooLayer(1),
	'Faixas de Voo Foto::Lote 2':  createFaixaVooLayer(2),
	'Faixas de Voo Foto::Lote 3':  createFaixaVooLayer(3),
	'Faixas de Voo Foto::Lote 4':  createFaixaVooLayer(4),
	'Faixas de Voo Foto::Lote 5':  createFaixaVooLayer(5),
	'Faixas de Voo Foto::Lote 6':  createFaixaVooLayer(6),
	'Faixas de Voo Foto::Lote 7':  createFaixaVooLayer(7),
	'Faixas de Voo Foto::Lote 8':  createFaixaVooLayer(8),
	'Faixas de Voo Foto::Lote 9':  createFaixaVooLayer(9),
	'Faixas de Voo Foto::Lote 10': createFaixaVooLayer(10),
	'Faixas de Voo Foto::Lote 11': createFaixaVooLayer(11),
	'Faixas de Voo Foto::Lote 12': createFaixaVooLayer(12),
};